import {
  useCustomTaxOptions,
  useNoTaxOptions,
} from '@webapp/components/TaxSelect/hooks/useCustomTaxOptions'
import { type OrderItemTax, type Tax } from '@webapp/models'
import { TaxTypes } from '@webapp/models/enums/Tax'

export const isTaxOptionType = (
  taxOptionName: OrderItemTax['name'],
  taxOptions
) =>
  taxOptions.map((option) => option.name).some((name) => name === taxOptionName)

export const isCustomTaxOption = (taxOptionName: OrderItemTax['name']) =>
  isTaxOptionType(taxOptionName, useCustomTaxOptions())

export const isNoTaxOption = (taxOptionName: OrderItemTax['name']) =>
  isTaxOptionType(taxOptionName, useNoTaxOptions())

export const calculateTax = (
  taxValue: OrderItemTax['value'],
  taxType: OrderItemTax['type'],
  calculatedSubtotal: number
) => {
  if (taxValue && taxType) {
    return taxType === TaxTypes.PERCENT
      ? calculatedSubtotal * (parseFloat(taxValue) / 100)
      : parseFloat(taxValue)
  }
  return 0
}

export const isLegacyTax = (tax: OrderItemTax, preset: Tax, taxValue) => {
  if (!preset) return true

  return preset?.name === tax?.name
    ? Number(taxValue) !== Number(preset?.percentage) * 100
    : false
}
